import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  Container,
  Media,
  Popover,
  PopoverBody,
  PopoverHeader,
} from "reactstrap";
import "./SellerChat.scss";
import { ToastContainer } from "react-toastify";
import { useEffect, useMemo, useRef, useState } from "react";
import ord from "../../assets/images/Component 27.png";
import pro from "../../assets/images/joj1.png";
import cam from "../../assets/images/joj2.png";
import Search from "../../assets/images/searchBlue.png";
import ayeza from "../../assets/images/ayeza-khan-img.png";
import WhatsAppIcon from "../../assets/images/WhatsAppIcon.png";
import PhonesAppIcon from "../../assets/images/PhoneNumberIcon.png";
import PlusIcon from "../../assets/images/add-circle-gray.png";
import EmojiHappy from "../../assets/images/emoji-happy.png";
import greenvoice from "../../assets/images/greenvoice.webp";
import locationIcon from "../../assets/images/locationPink.png";
import MountainDew from "../../assets/images/MountianDew.png";
import MicrePhone from "../../assets/images/microphoneGray.png";
import Send from "../../assets/images/send-2.png";
import shop from "../../assets/images/HomeFill.png";
import { MediaMetaData } from "helpers/models/media.model";
import profile from "../../assets/images/buyPass-favicon.png";

import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import {
  FirebaseAuthBackend,
  getFirebaseBackend,
  getFirestoreInstance,
} from "../../helpers/firebase_helper";
import { fetchOrderDetail, getActivies } from "live-slices/thunk";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  chatOrder,
  chatProduct,
  chatVoucher,
  createChatAdminThunk,
  createChatConfig,
  createChatRiderThunk,
} from "live-slices/chat/thunk";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { Autocomplete, GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import TrackOrderMOdal from "pages/Ecommerce/EcommerceOrders/components/TrackOrder";
import { createSelector } from "reselect";
import ChatModal from "./commpotents/chatOrderHistoryModal";
import ChatSelectOrderModal from "./commpotents/chatSelectOrderModal";
import VouchersModal from "./commpotents/vouchersModal";
import { getProducts as onGetProducts } from "live-slices/products/thunk";
import { onSnapshot } from "firebase/firestore";
import EmojiPicker from "emoji-picker-react";
import { Theme } from "emoji-picker-react"
import { getS3Upload } from "helpers/backend_helper";

type ChatType = {
  id: string;
  userIds: string[];
  messages?: any[];
  createdAt?: any;
  sourceId?: any;
  modifiedOn?: any;
  isAdmin?: any;
  sourceType?: any
};

const MainChat = (props: any) => {
  const [activeTab, setActiveTab] = useState("customers");
  const [activeStatus, setActiveStatus] = useState("all");
  const [chats, setChats] = useState<ChatType[]>([]);
  const [sellerChat, setSellerChat] = useState<ChatType | null>(null);
  const [orderData, setOrderData] = useState<any>(null);
  const history = useNavigate();
  const [selectedSourceId, setSelectedSourceId] = useState<string>("");
  const [selectedChat, setSelectedChat] = useState<any>("");
  const [message, setMessage] = useState("");
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [messages, setMessages] = useState<any[]>([]);
  const messagesEndRef = useRef<HTMLDivElement | null>(null);
  const firebaseHelper: FirebaseAuthBackend | null = getFirebaseBackend();
  const [uploadedFiles, setUploadedFiles] = useState<Media[]>([]);
  const [mediaRecorder, setMediaRecorder] = useState<MediaRecorder | null>(
    null
  );
  const [audioChunks, setAudioChunks] = useState<Blob[]>([]);
  const [audioBlob, setAudioBlob] = useState<Blob | null>(null);
  const [uploadedImageUrl, setUploadedImageUrl] = useState<string | null>(null);
  const [showMap, setShowMap] = useState(false); // To show/hide the map
  const [locationObject, setLocationObject] = useState<any>(null);
  const [isSending, setIsSending] = useState(false);
  const [zoomLevel] = useState(10); // Zoom level for the map
  const [mapCenter, setMapCenter] = useState({
    lat: 24.8615,
    lng: 67.0099,
  });

  const [markerPosition, setMarkerPosition] = useState<any>(null);
  const [trackOrderModal, setTrackOrderModal] = useState(false);
  const [chatModal, setChatModal] = useState<boolean>(false);
  const [selectedProductuserId, setselectedProductuserId] = useState<any>();
  const [vouchersModal, setVouchersModal] = useState<boolean>(false);
  const [isRecording, setIsRecording] = useState(false);
  const [chatSelectOrderModal, setChatSelectOrderModal] =
    useState<boolean>(false);
  const [selectedOrder, setSelectedOrder] = useState<any>(null);
  const [selectedOrderProduct, setSelectedProduct] = useState<any>(null);
  const [riderCount, setRiderCount] = useState<any>(null);
  const [adminCount, setAdminCount] = useState<any>(null);
  const [customerCount, setCustomerCount] = useState<any>(null);
  const [selectedOrderVoucher, setSelectedVoucher] = useState<any>(null);
  const [activeId, setActiveId] = useState(null);
  const [moreActions, setMoreActions] = useState(false);
  const [userSideBar, setUserSideBar] = useState(false);
  const toggle = () => setPopoverOpen(!popoverOpen);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState("");
  const order = location.state?.order;
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [autocomplete, setAutocomplete] = useState<google.maps.places.Autocomplete | null>(null);
  const [selectedLocation, setSelectedLocation] = useState<{
    lat: number;
    lng: number;
  } | null>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const selecteOrderData = createSelector(
    (state: any) => state.Orders,
    (activies) => activies?.activies
  );

  const activities = useSelector(selecteOrderData);

  const selecteOrderDetailData = createSelector(
    (state: any) => state.Orders,
    (orderDetail) => orderDetail?.orderDetail
  );

  const orderInfo = useSelector(selecteOrderDetailData);

  const selectedChatOrder = createSelector(
    (state: any) => state.Chat,
    (orderChat) => orderChat?.orderChat
  );

  const chatOrderData = useSelector(selectedChatOrder);

  const selectedChatVoucher = createSelector(
    (state: any) => state.Chat,
    (orderVoucher) => orderVoucher?.orderVoucher
  );

  const chatVoucherData = useSelector(selectedChatVoucher);

  const selectedChatProduct = createSelector(
    (state: any) => state.Chat,
    (orderProduct) => orderProduct?.orderProduct
  );

  const chatProductData = useSelector(selectedChatProduct);
  const emojiRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (emojiRef.current && !emojiRef.current.contains(event.target as Node)) {
        setShowEmojiPicker(false);
      }
    };

    if (showEmojiPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showEmojiPicker]);

  useEffect(() => {
    console.log(order);
    dispatch(fetchOrderDetail(selectedSourceId));
  }, [selectedSourceId]);

  useEffect(() => {
    console.log(orderData);
    scrollToBottom();
  }, [messages]);

  const handleImageClick = () => {
    fileInputRef.current?.click();
  };

  const getUploadUrl = async (file: File): Promise<string | null> => {
          try {
              const fileName = encodeURIComponent(file.name);
  
              const res: any = await getS3Upload(fileName,file.type); // Your API returns { uploadUrl }
              const uploadUrl = res?.data?.uploadUrl;
  
              if (uploadUrl) {
                  const myHeaders = new Headers();
                  myHeaders.append("Content-Type", file.type);
                  const requestOptions: any = {
                      method: "PUT",
                      headers: myHeaders,
                      body: file,
                      redirect: "follow"
                  };
                  await fetch(uploadUrl, requestOptions);
              }
  
              return res.data.fileUrl;
          } catch (err) {
              console.error("S3 upload error", err);
              return null;
          }
      };
      
  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const firebaseHelper: any = getFirebaseBackend();
    if (!firebaseHelper) return;

    try {
      const url :any= await getUploadUrl(file);
      const thumbnail: string | null = await generateThumbnail(file);

      if (url && thumbnail) {
        const mediaPayload = new Media(
          url,
          new MediaMetaData(
            (file as any).height || 0,
            (file as any).width || 0,
            file.type || "file",
            file.name.split(".").pop() || "",
            file.name || "",
            (file as any).duration || 0
          )
        );

        setUploadedFiles((prevFiles) => [...prevFiles, mediaPayload]);
        setUploadedImageUrl(url); // ✅ Set the uploaded image URL
        console.log("Uploaded image & thumbnail ✅", mediaPayload, thumbnail);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const generateThumbnail = (file: File): Promise<string | null> => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const objectURL = URL.createObjectURL(file);
      img.src = objectURL;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const maxWidth = 150;
        const maxHeight = 150;

        const ratio = Math.min(maxWidth / img.width, maxHeight / img.height);
        const width = img.width * ratio;
        const height = img.height * ratio;

        canvas.width = width;
        canvas.height = height;
        ctx?.drawImage(img, 0, 0, width, height);

        const thumbnail = canvas.toDataURL("image/jpeg");
        resolve(thumbnail);
      };

      img.onerror = reject;
    });
  };

  useEffect(() => {
    getChats();
    getAdminChats();
    getChatByBuyerSeller();
  }, []);

  useEffect(() => {
    const unsubscribe = getChats();
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (selectedChat?._id) {
      let chatId = selectedChat._id;

      if (typeof chatId !== "string") {
        try {
          const binary = selectedChat._id?.buffer?._byteString?.binaryString;
          if (binary) {
            chatId = [...binary]
              .map((char) => char.charCodeAt(0).toString(16).padStart(2, "0"))
              .join("");
          }
        } catch (e) {
          console.error("❌ Error converting chatId to hex string:", e);
        }
      }

      if (chatId) {
        getMessagesForSelectedChat(chatId);
      }
    }
  }, [selectedChat?._id]);

  const senderData = selectedChat?.members?.find(
    (m: any) => m.type === "sender"
  );
  const receiverData = selectedChat?.members?.find(
    (m: any) => m.type === "receiver"
  );

  const getSellerIdFromLocalStorage = () => {
    const seller = localStorage.getItem("seller");
    return seller ? JSON.parse(seller).sellerId : null;
  };

  const seller = JSON.parse(localStorage.getItem("seller") || "{}");

  const dispatch: any = useDispatch();
  const handleChatClick = async (
    sourceId: string,
    sourceType: string,
    selectedChat: any
  ) => {
    console.log("Source ID:", orderData);
    console.log("Source Type:", sourceType);
    if (sourceType === "product") {
      setselectedProductuserId(selectedChat.userIds[1]); // ✅ Correct
    }

    setUserSideBar(false);
    setSelectedSourceId(sourceId);
    setSelectedChat(selectedChat);
    if (sourceType === "order") {
      const result = await dispatch(fetchOrderDetail(sourceId));
      const data = result.payload;
      console.log("Fetched Order Data:", data);

      setOrderData(data);
    }
  };

  let unsubscribeConversation: any = null;

  const getMessagesForSelectedChat = async (_id: string) => {
    try {
      if (unsubscribeConversation) {
        unsubscribeConversation();
      }
      const db = getFirestoreInstance();
      const chatDocRef = doc(db, "buypass-chats", _id);
      const chatDocSnapshot = await getDoc(chatDocRef);

      if (!chatDocSnapshot.exists()) {
        console.warn(`❗ Chat document not found for ID: ${_id}`);
        return;
      }

      unsubscribeConversation = onSnapshot(
        collection(chatDocRef, "buypass-messages"),
        (messagesSnapshot) => {
          const chatMessages = messagesSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          setMessages(chatMessages); // ✅ Yeh ab real-time update karega
          console.log("📨 Real-time messages for selected chat:", chatMessages);
        },
        (error) => {
          console.error("❌ Error with real-time message listener:", error);
        }
      );
    } catch (error) {
      console.error("❌ Error setting up real-time listener:", error);
    }
  };

  const truncate = (str: string, maxLength: number) => {
    return str?.length > maxLength ? str.slice(0, maxLength) + "..." : str;
  };
  const getChats = () => {
    try {
      const db = getFirestoreInstance();
      const q = query(
        collection(db, "buypass-chats"),
        where("chatType", "==", "riderSeller")
      );

      const sellerId = getSellerIdFromLocalStorage();
      if (!sellerId) {
        console.warn("Seller ID not found.");
        setChats([]);
        return;
      }

      // Snapshot listener
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const allChats = querySnapshot.docs.map((doc: any) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const matchedChats = allChats
          .filter(
            (chat: any) =>
              Array.isArray(chat.userIds) &&
              chat.userIds.map(String).includes(String(sellerId))
          )
          .sort((a: any, b: any) => {
            const aTime = a.lastMessage?.createdOn || 0;
            const bTime = b.lastMessage?.createdOn || 0;
            return bTime - aTime; // 🔽 newest first
          });

        if (matchedChats.length > 0) {
          setRiderCount(matchedChats.length);
          setSellerChat(matchedChats[0]);
          setChats(matchedChats);
          setActiveTab('riders');
        } else {
          setChats([]);
        }
      });

      return unsubscribe;
    } catch (error) {
      console.error("❌ Error getting chats (snapshot):", error);
      setChats([]);
    }
  };

  const getChatByBuyerSeller = () => {
    try {
      const db = getFirestoreInstance();
      const q = query(
        collection(db, "buypass-chats"),
        where("chatType", "==", "buyerSeller")
      );

      const sellerId = getSellerIdFromLocalStorage();
      if (!sellerId) {
        console.warn("Seller ID not found.");
        setChats([]);
        return;
      }

      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const allChats = querySnapshot.docs.map((doc: any) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const matchedChats = allChats
          .filter(
            (chat: any) =>
              Array.isArray(chat.userIds) &&
              chat.userIds.map(String).includes(String(sellerId))
          )
          .sort((a: any, b: any) => {
            const aTime = a.lastMessage?.createdOn || 0;
            const bTime = b.lastMessage?.createdOn || 0;
            return bTime - aTime; // 🔽 descending
          });

        if (matchedChats.length > 0) {
          setCustomerCount(matchedChats.length);
          setSellerChat(matchedChats[0]);
          setChats(matchedChats);
          setActiveTab('customers')
        } else {
          setChats([]);
        }
      });

      return unsubscribe;
    } catch (error) {
      console.error("❌ Error getting chats (snapshot):", error);
      setChats([]);
    }
  };

  const getAdminChats = () => {
    try {
      const db = getFirestoreInstance();
      const q = query(
        collection(db, "buypass-chats"),
        where("chatType", "==", "adminSeller")
      );

      const sellerId = getSellerIdFromLocalStorage();
      if (!sellerId) {
        console.warn("Seller ID not found.");
        setChats([]);
        return;
      }

      // Snapshot listener
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const allChats = querySnapshot.docs.map((doc: any) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const matchedChats = allChats
          .filter(
            (chat: any) =>
              Array.isArray(chat.userIds) &&
              chat.userIds.map(String).includes(String(sellerId))
          )
          .sort((a: any, b: any) => {
            const aTime = a.lastMessage?.createdOn || 0;
            const bTime = b.lastMessage?.createdOn || 0;
            return bTime - aTime; // 🔽 newest first
          });

        if (matchedChats.length > 0) {
          console.log(matchedChats, "hamza");
          setAdminCount(matchedChats.length);
          setSellerChat(matchedChats[0]);
          setChats(matchedChats);
          setActiveTab('admin');
        } else {
          setChats([]);
        }
      });

      return unsubscribe;
    } catch (error) {
      console.error("❌ Error getting chats (snapshot):", error);
      setChats([]);
    }
  };

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      let chunks: Blob[] = [];

      recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          chunks.push(event.data);
        }
      };

      recorder.onstop = () => {
        if (chunks.length > 0) {
          const blob = new Blob(chunks, { type: "audio/webm" });
          setAudioBlob(blob);
        } else {
          setAudioBlob(null);
        }
        setAudioChunks([]);
        setIsRecording(false); // ✅ stop hone ke baad
      };

      recorder.start();
      setAudioChunks(chunks);
      setMediaRecorder(recorder);
      setIsRecording(true); // ✅ recording started
      console.log("🎤 Recording started...");
    } catch (err) {
      console.error("🎙️ Error starting recording:", err);
    }
  };

  const stopRecording = (shouldClear = false) => {
    if (mediaRecorder && mediaRecorder.state !== "inactive") {
      mediaRecorder.onstop = () => {
        if (shouldClear) {
          setAudioBlob(null); // ✅ manually clear
        } else {
          const blob = new Blob(audioChunks, { type: "audio/webm" });
          setAudioBlob(blob);
        }
        setAudioChunks([]);
        setIsRecording(false);
        setMediaRecorder(null);
      };
      mediaRecorder.stop();
      // setMediaRecorder(null);
      // setAudioBlob(null);
    }
  };

  const uploadAudioToFirebase = async (blob: Blob): Promise<string | null> => {
    try {
      const storage = getStorage();
      const audioRef = ref(storage, `voiceNotes/${Date.now()}.webm`);
      const snapshot = await uploadBytes(audioRef, blob);
      const downloadURL = await getDownloadURL(snapshot.ref);
      console.log("✅ Uploaded to Firebase:", downloadURL);
      return downloadURL;
    } catch (error) {
      console.error("❌ Error uploading to Firebase:", error);
      return null;
    }
  };

  const uploadAudioToS3 = async (blob: Blob): Promise<string | null> => {
  try {
    const file = new File([blob], `${Date.now()}.webm`, { type: "audio/webm" });
    const uploadedFileUrl = await getUploadUrl(file);

    if (uploadedFileUrl) {
      console.log("✅ Uploaded to S3:", uploadedFileUrl);
      return uploadedFileUrl;
    }

    return null;
  } catch (error) {
    console.error("❌ Error uploading to S3:", error);
    return null;
  }
};

  const handleSendMessage = async (
    order?: any,
    product?: any,
    voucher?: any,
    location?: any
  ) => {
    if (isSending) {
      console.warn("⏳ Message already sending... Skipping duplicate.");
      return;
    }
    setIsSending(true);
    const specificReceiverId = "4d457bb4-cd5d-409d-902b-969ca39816bd";
    const memberWithSpecificId = selectedChat?.members?.find(
      (m: any) => m.id === specificReceiverId
    );
    const fallbackSender = selectedChat?.members?.find(
      (m: any) => m.type === "sender"
    );

    const receiverData = memberWithSpecificId || fallbackSender;

    if (!receiverData) {
      console.error("❌ No receiver data found.");
      setIsSending(false);
      return;
    }

    let chatId = selectedChat?._id;

    if (typeof chatId !== "string") {
      try {
        const binary = chatId?.buffer?._byteString?.binaryString;
        if (binary) {
          chatId = [...binary]
            .map((char) => char.charCodeAt(0).toString(16).padStart(2, "0"))
            .join("");
        }
      } catch (e) {
        console.error("❌ Error converting chatId to hex string:", e);
        setIsSending(false);
        return;
      }
    }

    const receiver = {
      id: receiverData.id,
      name: receiverData.name,
      email: receiverData.email,
      url: receiverData.url,
      phoneNumber: receiverData.phoneNumber,
    };

    try {
      let payload;
      if (uploadedImageUrl) {
        payload = {
          chatId,
          type: "image",
          media: {
            url: uploadedImageUrl,
            format: "image/jpeg",
            mediaType: "image",
          },
          receiver,
        };
        setUploadedImageUrl(null);
      } 
      else if (audioBlob) {
        stopRecording();
        const firebaseUrl = await uploadAudioToS3(audioBlob);
        if (!firebaseUrl) {
          setIsSending(false);
          return;
        }
        payload = {
          chatId,
          type: "audio",
          media: {
            url: firebaseUrl,
            format: "audio/webm",
            mediaType: "voice",
          },
          receiver,
        };
        setAudioBlob(null);
      } else if (voucher) {
        payload = {
          chatId,
          type: "data",
          options: {
            type: "voucher",
            id: voucher.id,
            name: voucher.promotionName,
            discountPercentage: voucher.discountPercentage,
            flatAmount: voucher.flatAmount,
            // description: voucher.description,
            validUntil: voucher.createdOn,
          },
          receiver,
        };
        setVouchersModal(false);
        setSelectedVoucher(null);
      } else if (product) {
        payload = {
          chatId,
          type: "data",
          options: {
            type: "product",
            id: product._id,
            buypassId: product.buypassId, 
            name: product.nameEn,
            description: product.description,
            url: product.image,
            sellerId: product.seller._id,
            sellerName: product.seller.name,
            price: product.price,
            createdOn: product.createdOn,
          },
          receiver,
        };
        setChatSelectOrderModal(false);
        setChatModal(false);
        setSelectedProduct(null);
      } else if (order) {
        payload = {
          chatId,
          type: "data",
          options: {
            type: "order",
            id: order.id,
            buypassId: order.buypassId, 
            name: order.name,
            description: order.description,
            url: order.url,
            sellerId: order.sellerId,
            sellerName: order.sellerName,
            price: order.price,
            createdOn: order.createdOn,
          },
          receiver,
        };
        setChatModal(false);
        setSelectedOrder(null); // Reset selection
      } else if (location) {
        payload = {
          chatId,
          type: "location",
          location: {
            coordinates: [location.lng, location.lat],
            streetAddress: location.streetAddress,
            type: "Point",
          },
          receiver,
        };
        setLocationObject(null);
        setMarkerPosition(null);
      } else if (message.trim()) {
        payload = {
          chatId,
          type: "text",
          text: message.trim(),
          receiver,
        };
        setMessage("");
      }
      if (payload) {
        await dispatch(createChatConfig(payload)).unwrap();
      }
      console.log("✅ Message Sent");
    } catch (err) {
      console.error("❌ Error sending message:", err);
    }
    setIsSending(false); // 🔓 Unlock after complete
  };


  const filteredChats = useMemo(() => {
    return chats.filter((chat: any) => {
      const otherMember = chat?.members?.find(
        (m: any) => m.id !== seller?.sellerId
      );
      if (!otherMember || !otherMember.name) return false;

      return otherMember.name.toLowerCase().includes(searchQuery.toLowerCase());
    });
  }, [chats, searchQuery, seller?.sellerId]);

  const handleSendOrder = (orderPayload: any) => {
    setSelectedOrder(orderPayload);
    handleSendMessage(orderPayload);
  };

  const handleSendProduct = (productPayload: any) => {
    setSelectedProduct(productPayload);
    handleSendMessage(undefined, productPayload);
  };

  const handleSendVoucher = (voucherPayload: any) => {
    setSelectedVoucher(voucherPayload);
    handleSendMessage(undefined, undefined, voucherPayload);
  };

  const onMapClick = async (e: google.maps.MapMouseEvent) => {
    if (!e.latLng) return;

    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    try {
      const streetAddress = await getAddressFromCoordinates(lat, lng);

      setLocationObject({
        lat,
        lng,
        streetAddress,
      });

      setMarkerPosition({ lat, lng });
    } catch (error) {
      console.error("Geocoding error:", error);
      setLocationObject({
        lat,
        lng,
        streetAddress: "No address found.",
      });
      setMarkerPosition({ lat, lng });
    }
  };

  // Helper function to wrap geocoder in a Promise
  const getAddressFromCoordinates = (
    lat: number,
    lng: number
  ): Promise<string> => {
    return new Promise((resolve, reject) => {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results && results[0]) {
          resolve(results[0].formatted_address);
        } else if (status === "ZERO_RESULTS") {
          resolve("No address found.");
        } else {
          reject("Geocoder failed: " + status);
        }
      });
    });
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          setMapCenter({ lat, lng });
          setMarkerPosition({ lat, lng });

          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ location: { lat, lng } }, (results, status) => {
            if (status === "OK" && results && results[0]) {
              const streetAddress = results[0].formatted_address;
              setLocationObject({
                lat,
                lng,
                streetAddress,
              });
            } else {
              console.error("Geocoder failed:", status);
            }
          });
        },
        (error) => {
          console.error("Error getting current location:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }, []);

  useEffect(() => {
    if (trackOrderModal) {
      console.log(messages);

      dispatch(getActivies({ orderId: selectedSourceId }));
      console.log(orderData);
    }
  }, [trackOrderModal]);

  useEffect(() => {
    if (chatModal) {
      dispatch(chatOrder({ userId: orderData?.userDetails?._id || selectedProductuserId }));
      console.log(chatOrderData);
    }
    if (vouchersModal) {
      dispatch(chatVoucher({ userId: orderData?.userDetails?._id || selectedProductuserId }));
      console.log(chatVoucherData);
    }
    if (chatSelectOrderModal) {
      dispatch(
        onGetProducts({
          page: 1,
          count: 10,
          status: "active",
          keyword: "",
        })
      );
      console.log(chatOrderData);
    }
  }, [chatModal, chatSelectOrderModal, vouchersModal, dispatch]);

  const calledRef = useRef(false);

  useEffect(() => {
    if (!order || calledRef.current) return;

    const createChatAndOpen = async () => {
      calledRef.current = true;

      const chatPayload = {
        chatType: "riderSeller",
        sourceId: order?.id.toString(),
        sourceType: "order",
        userIds: [order.assignRider?._id],
        receiver: {
          id: order?.assignRider?._id,
          name: order?.assignRider?.name,
          email: order?.assignRider?.email,
          phoneNumber: order?.assignRider?.phoneNumber,
          url: order?.assignRider?.profilePicture?.url,
        },
      };

      const result = await dispatch(createChatRiderThunk(chatPayload));
      const newChat = result?.payload;

      if (newChat) {
        setSelectedChat(newChat);
        setSelectedSourceId(order._id);
        const orderResult = await dispatch(fetchOrderDetail(order._id));
        setOrderData(orderResult.payload);
      }
    };

    createChatAndOpen();
  }, [dispatch, order]);

  const receiver = (selectedChat as any)?.members?.find(
    (m: any) => m.type === "receiver"
  );

  const members = (selectedChat as any)?.members?.find(
    (m: any) => m.type === "sender"
  );
  const phoneNumber = receiver?.phoneNumber || members?.phoneNumber;
  const formattedWhatsApp = phoneNumber?.replace(/^0/, "92");
  const formattedPhone = phoneNumber?.replace(/^0/, "+92");

  const handleStartAdminChat = async () => {
    const chatPayload = {
      chatType: "adminSeller",
    };

    const result = await dispatch(createChatAdminThunk(chatPayload));
    const newChat = result?.payload;

    if (newChat) {
      setSelectedChat(newChat);
      setSelectedSourceId(order?._id);
      const orderResult = await dispatch(fetchOrderDetail(order._id));
      setOrderData(orderResult.payload);
    }
  };

  const onLoadAutocomplete = (auto: any) => {
    setAutocomplete(auto);
  };
  // const { isLoaded } = useJsApiLoader({
  //   googleMapsApiKey: "AIzaSyCMct0m0boGi9OwuQ43XWH8j5xPce0g6rU",
  //   libraries: ['places'],
  // });


  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      const lat = place.geometry?.location?.lat();
      const lng = place.geometry?.location?.lng();

      if (lat && lng) {
        setMapCenter({ lat, lng });
        setMarkerPosition({ lat, lng });
        setLocationObject({
          lat,
          lng,
          streetAddress: place.formatted_address || place.name || "",
        });
      }
    }
  };

  return (
    <div className="page-content Chat-Main">
      <TrackOrderMOdal
        show={trackOrderModal}
        onCloseClick={() => setTrackOrderModal(false)}
        activities={activities}
        order={orderInfo}
      />
      <ChatModal
        show={chatModal}
        onCloseClick={() => setChatModal(false)}
        orderData={chatOrderData}
        handleSendOrder={handleSendOrder}
      />

      <ChatSelectOrderModal
        show={chatSelectOrderModal}
        onCloseClick={() => setChatSelectOrderModal(false)}
        productData={chatProductData}
        handleSendOrder={handleSendProduct}
      />

      <VouchersModal
        show={vouchersModal}
        onCloseClick={() => setVouchersModal(false)}
        voucherData={chatVoucherData}
        handleSendOrder={handleSendVoucher}
      />

      {showMap && (
        <div className="map-modal mapModalmobileRes"
          style={{ height: '35%', top: '36%' }}>
          <Autocomplete onLoad={onLoadAutocomplete} onPlaceChanged={onPlaceChanged}>
            <input
              type="text"
              placeholder="Search location..."
              style={{
                width: "100%",
                height: "40px",
                marginBottom: "10px",
                padding: "0 10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            />
          </Autocomplete>

          <GoogleMap
            mapContainerStyle={{ width: "100%", height: "80%" }}
            center={mapCenter}
            zoom={zoomLevel}
            onClick={onMapClick}
          >
            {markerPosition && <MarkerF position={markerPosition} />}
          </GoogleMap>

          <div className="w-100 mt-3 d-flex gap-3  justify-content-end">
            <button
              className="bg-danger"
              data-testing-id="Cancel_Location"
              style={{ borderRadius: "8px", color: "#fff" }}
              onClick={() => setShowMap(false)}
            >
              Cancel
            </button>
            <button
              data-testing-id="Confirm_Location"

              style={{ borderRadius: "8px" }}
              onClick={() => {
                setShowMap(false);
                handleSendMessage(
                  undefined,
                  undefined,
                  undefined,
                  locationObject
                );
              }}
            >
              Confirm Location
            </button>
          </div>
        </div>
      )}
      <ToastContainer />
      <Container fluid>
        <BreadCrumb
          title="Message center"
          pageTitle="Chat"
          pageTitleRoute="/Seller-Chat"
        />

        <Card className="ChatCard-Main">
          <div
            className={`ChatDV-Main ${userSideBar || !selectedChat ? "userSideBarOn" : ""
              }`}
          >
            <div className="ColOne-Main">
              {/* <div
                className="userSideSwitch"
                onClick={() => setUserSideBar(!userSideBar)}
              >
                <i className="ri-close-line"></i>
              </div> */}
              <div className="TabBarAnd_Search">
                <div className=""></div>
                <div className="tab-bar">
                  <div
                    data-testing-id="customers_Seller"
                    className={`tab ${activeTab === "customers" ? "active" : ""
                      }`}
                    onClick={() => {
                      setActiveTab("customers");
                      getChatByBuyerSeller();
                      setSelectedChat(null);
                      setSearchQuery("");
                    }}
                  >
                    Customers
                    <span>{String(customerCount || 0).padStart(2, "0")}</span>
                  </div>

                  <div
                    data-testing-id="riders_Seller"
                    className={`tab ${activeTab === "riders" ? "active" : ""}`}
                    onClick={() => {
                      setActiveTab("riders");
                      getChats();
                      setSelectedChat(null);
                      setSearchQuery("");
                    }}
                  >
                    Riders
                    <span>{String(riderCount || 0).padStart(2, "0")}</span>
                  </div>
                  <div
                    data-testing-id="admin_Seller"
                    className={`tab ${activeTab === "admin" ? "active" : ""}`}
                    onClick={() => {
                      setActiveTab("admin");
                      getAdminChats();
                      setSelectedChat(null);
                      setSearchQuery("");
                    }}
                  >
                    Admin
                    <span>{String(adminCount || 0).padStart(2, "0")}</span>
                  </div>
                </div>
                <div className="search">
                  <input
                    type="text"
                    placeholder="Search chat or user name"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />

                  <img src={Search} alt="" />
                </div>
              </div>
              {/* <div className="StatusMain">
                <div className="Status-bar">
                  <div
                    className={`tab ${activeStatus === "all" ? "active" : ""}`}
                    onClick={() => setActiveStatus("all")}
                  >
                    All 
                  </div>
                  <div
                    className={`tab ${activeStatus === "read" ? "active" : ""
                      }`}
                    onClick={() => setActiveStatus("read")}
                  >
                    Read
                  </div>
                  <div
                    className={`tab ${activeStatus === "unread" ? "active" : ""
                      }`}
                    onClick={() => setActiveStatus("unread")}
                  >
                    Unread
                  </div>

                </div>
              </div> */}
              <div className="MembersMain">
                {activeTab === "admin" && chats.length === 0 ? (
                  <div className="no-chats">
                    <button
                      className="start-button"
                      onClick={handleStartAdminChat}
                    >
                      Start
                    </button>
                  </div>
                ) : filteredChats.length === 0 ? (
                  <div className="no-chats w-100 d-flex justify-content-center align-items-center">
                    <h4>No Chat Found !</h4>
                  </div>
                ) : (
                  filteredChats.map((item: any, index: any) => (
                    <div
                      data-test-id={"meMber" + index}
                      className={`member ${selectedChat?.id === item.id ? "memberActive" : ""
                        }`}
                      onClick={() =>
                        handleChatClick(item.sourceId, item.sourceType, item)
                      }
                      key={item.id || index}
                    >
                      <div className="profile">
                        <img
                          src={item?.lastMessage?.sender?.url || item?.members[0]?.url || profile}
                          alt=""
                        />
                        <div className="dot"></div>
                      </div>
                      <div className="w-100">
                        <div className="d-flex justify-content-between">
                          <h1>
                            {
                              item?.members?.find(
                                (m: any) => m.id !== seller.sellerId
                              )?.name
                            }
                          </h1>
                          <div className="status">
                            <div className="dot"></div>
                          </div>
                        </div>
                        <h6 data-testing-id={"orderId_mainChat" + index}>
                          <span>
                            {item?.lastMessage?.type === "text" ? (
                              <span>{item?.lastMessage?.text}</span>
                            ) : item?.lastMessage?.type === "location" ? (
                              <span>📍 Location message</span>
                            ) : item?.lastMessage?.type === "audio" ? (
                              <span>🎧 Audio message</span>
                            ) : item?.lastMessage?.type === "image" ? (
                              <span>🖼️ Image message</span>
                            ) : item?.lastMessage?.type === "product_order" ? (
                              <span>🛒 Product Order Received</span>
                            ) : item?.lastMessage?.type === "voucher" ? (
                              <span>🎟️ Voucher Sent</span>
                            ) : item?.lastMessage?.type === "data" ? (
                              item?.lastMessage?.options?.type === "order" ? (
                                <span>📦 Order Data</span>
                              ) : item?.lastMessage?.options?.type ===
                                "product" ? (
                                <span>🛍️ Product Data</span>
                              ) : item?.lastMessage?.options?.type ===
                                "voucher" ? (
                                <span>🎫 Voucher Data</span>
                              ) : (
                                <span>📁 New message</span>
                              )
                            ) : (
                              <span>❓ You have received a new message</span>
                            )}
                          </span>
                        </h6>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
            {selectedChat && (
              <div className="ColTwo-Main">
                <div className="headerMain_COL">
                  <div className="d-flex justify-content-start align-items-center gap-2">
                    <div
                      className="userSideSwitch"
                      onClick={() => setUserSideBar(!userSideBar)}
                    >
                      <i className="ri-menu-line"></i>
                    </div>
                    <div className="riderName">
                      <img src={selectedChat?.members[0]?.url || profile} alt="" />
                      <div>
                        <h1>
                          {
                            (selectedChat as any)?.members?.find(
                              (m: any) => m.id !== seller.sellerId
                            )?.name
                          }
                        </h1>
                        <p>
                          {selectedChat.chatType === "adminSeller" ? (
                            <></>
                          ) : (
                            <>
                              {selectedChat.chatType === "riderSeller" ? "Rider ID" : "Customer ID"}:{" "}
                              <span>
                                {
                                  (selectedChat as any)?.members?.find(
                                    (m: any) => m.id !== seller.sellerId
                                  )?.id
                                }
                              </span>
                            </>
                          )}

                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <div className="CurrentLocation">
                    <p>Current Location:</p>
                    <h1>Sadar Bazar</h1>
                    <div className="d-flex gap-1 align-items-center">
                      <img src={Location} alt="" />
                      <a>Sector 34 shop</a>
                    </div>
                  </div> */}
                  <div className="d-flex gap-2 align-items-center justify-content-end callsSection">
                    {sellerChat?.sourceType !== "product" && (
                      <div className="CurrentLocation">
                        <p>Item Delivered:</p>
                        <h1>{orderData?.items?.length || 0}</h1>
                      </div>
                    )}
                    {phoneNumber && (
                      <div className="IconCall">
                        <a
                          href={`https://wa.me/${formattedWhatsApp}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={WhatsAppIcon} alt="WhatsApp" />
                        </a>

                        <a href={`tel:${formattedPhone}`}>
                          <img
                            className="PhoneImg"
                            src={PhonesAppIcon}
                            alt="Phone"
                          />
                        </a>

                        <div>
                          <p>Call</p>
                          <h1>{phoneNumber}</h1>
                        </div>
                      </div>
                    )}

                    {!sellerChat?.isAdmin && sellerChat?.sourceType !== "product" && (
                      <div className="boxOrder">
                        {/* <img src={BoxTIme} alt="" /> */}
                        <button
                          data-testing-id="VieworderDetails_mainChat"
                          onClick={() => setTrackOrderModal(true)}
                        >
                          View Order Details
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="MainChat-Column">
                  <div className="Column">
                    {/* <div className="datePipe">
                      <div className="border"></div>
                      <p>Today 2:45 PM</p>
                      <div className="border"></div>
                    </div> */}
                    <div className="Chat-Body-main">
                      <div className="ChatBody-Boxes">
                        {messages.map((msg: any, index: number) => (
                          <>
                            {msg?.options?.type === "voucher" && (
                              <div className="box">
                                <div className="d-flex gap-2 justify-content-end w-100">
                                  <h1>{seller?.fullName}</h1>
                                  <p>
                                    {(selectedChat as any)?.modifiedOn &&
                                      new Date(
                                        (selectedChat as any).modifiedOn
                                      ).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                      })}
                                  </p>
                                </div>
                                <h6>
  {" "}
  Hi, [
  {
    msg.sender?.id === seller?.sellerId
      ? (selectedChat?.members?.find((m: any) => m.id !== seller.sellerId)?.name || "Customer")
      : (orderData?.sellerName || seller?.fullName || "Seller")
  }
  ], can you confirm the status of Order #
  {msg?.options?.id || msg?.options?.buypassId || orderData?.id || "--"}?
</h6>
                                <div className="product_box">
                                  <div className="d-flex gap-2">
                                    <img src={shop} alt="" />
                                    <h2>
                                      {" "}
                                      {
                                        (selectedChat as any)?.members?.find(
                                          (m: any) => m.type === "receiver"
                                        )?.name
                                      }
                                    </h2>
                                    {/* <h2>{msg?.options?.sellerName || "--"}</h2> */}
                                  </div>
                                  <div className="productImage">
                                    {msg.options.flatAmount > 0 && (
                                      <h1
                                        style={{
                                          fontSize: "30px",
                                          fontWeight: "500",
                                          color: "#00CE7B",
                                          margin: "0px",
                                          padding: "0px",
                                        }}
                                      >
                                        Rs {msg?.options?.flatAmount}off
                                      </h1>
                                    )}
                                    {msg.options.discountPercentage > 0 && (
                                      <h1
                                        style={{
                                          fontSize: "30px",
                                          fontWeight: "500",
                                          color: "#00CE7B",
                                          margin: "0px",
                                          padding: "0px",
                                        }}
                                      >
                                        {msg?.options?.discountPercentage}%off
                                      </h1>
                                    )}

                                    <div className="SomeText">
                                      <a>
                                        Order ID: #{msg?.options?.id || "--"}
                                      </a>
                                      <p>{msg?.options?.name || "--"}</p>
                                      <h6>
                                        {/* {msg?.options?.description || "--"} */}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            <div
                              className="box"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                if (msg?.options?.id) {
                                  window.open(
                                    `/product/${msg.options.id}`,
                                    "_blank"
                                  );
                                }
                              }}
                            >
                              {msg?.options?.type === "product" && (
                                <div className="box">
                                  <div className="d-flex gap-2 justify-content-end w-100">
                                    <h1>{seller?.fullName}</h1>
                                    <p>
                                      {(selectedChat as any)?.modifiedOn &&
                                        new Date(
                                          (selectedChat as any).modifiedOn
                                        ).toLocaleTimeString([], {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: true,
                                        })}
                                    </p>
                                  </div>
                                  <h6>
  {" "}
  Hi, [
  {
    msg.sender?.id === seller?.sellerId
      ? (selectedChat?.members?.find((m: any) => m.id !== seller.sellerId)?.name || "Customer")
      : (msg?.options?.sellerName || seller?.fullName || "Seller")
  }
  ], can you confirm the status of product #
  {msg?.options?.id || msg?.options?.buypassId || "--"}?
</h6>
                                  <div className="product_box">
                                    <div className="d-flex gap-2">
                                      <img src={shop} alt="" />
                                      <h2>
                                        {msg?.options?.sellerName || "--"}
                                      </h2>
                                    </div>
                                    <div className="productImage">
                                      <img
                                        src={msg?.options?.url || profile}
                                        alt="Product Image"
                                      />
                                      <div className="SomeText">
                                        <a title={msg?.options?.buypassId || msg?.options?.id || "--"}>
                                          Product ID: #
                                          {msg?.options?.id || msg?.options?.buypassId ||  "--"}
                                        </a>
                                        <p>{msg?.options?.name || "--"}</p>
                                        <h6>{msg?.options?.price || "--"}</h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>

                            <div
                              className="box"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                if (msg?.options?.id) {
                                  window.open(
                                    `/order-detail/${msg.options.id}`,
                                    "_blank"
                                  );
                                }
                              }}
                            >
                              {msg?.options?.type === "order" && (
                                <div className="box">
                                  <div className="d-flex gap-2 justify-content-end w-100">
                                    <h1>{seller?.fullName}</h1>
                                    <p>
                                      {(selectedChat as any)?.modifiedOn &&
                                        new Date(
                                          (selectedChat as any).modifiedOn
                                        ).toLocaleTimeString([], {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: true,
                                        })}
                                    </p>
                                  </div>
<h6>
  {" "}
  Hi, [
  {
    msg.sender?.id === seller?.sellerId
      ? (selectedChat?.members?.find((m: any) => m.id !== seller.sellerId)?.name || "Customer")
      : (orderData?.sellerName || seller?.fullName || "Seller")
  }
  ], can you confirm the status of Order #
  {msg?.options?.buypassId || msg?.options?.id || orderData?.id || "--"}?
</h6>
                                  <div className="product_box">
                                    <div className="d-flex gap-2">
                                      <img src={shop} alt="" />
                                      <h2>
                                        {msg?.options?.sellerName || "--"}
                                      </h2>
                                    </div>
                                    <div className="productImage">
                                      <img
                                        src={msg?.options?.url || profile}
                                        alt="Product Image"
                                      />

                                      <div className="SomeText">
                                        <a title={msg?.options?.buypassId || msg?.options?.id || "--"}>
                                          Order ID: #{msg?.options?.buypassId || msg?.options?.id || "--"}
                                        </a>
                                        <p>{msg?.options?.name || "--"}</p>
                                        <h6>{msg?.options?.price || "--"}</h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            {/* {msg.text?.length > 0 && ( */}
                            <div
                              key={index}
                              className={`box ${msg.sender?.id === seller?.sellerId
                                ? "chat-left"
                                : "chat-right"
                                }`}
                            >
                              {msg.text?.length > 0 && (
                                <div
                                  className={`d-flex gap-2 ${msg.sender?.id === seller?.sellerId
                                    ? "justify-content-end"
                                    : "justify-content-start"
                                    } w-100`}
                                >
                                  <h1>
                                    {msg.sender?.name || "Rider Name"}
                                  </h1>
                                  <p>
                                    {new Date(msg.createdOn).toLocaleTimeString(
                                      [],
                                      {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                      }
                                    )}
                                  </p>
                                </div>
                              )}
                              {msg.text?.length > 0 && (
                                <div
                                  className={`d-flex gap-2 ${msg.sender?.id === seller?.sellerId
                                    ? "justify-content-end"
                                    : "justify-content-start"
                                    } w-100`}
                                >
                                  <h6 style={{ whiteSpace: "pre-line",wordBreak: "break-word" }}>{msg.text}</h6>
                                </div>
                              )}

                              <div
                                className={`d-flex gap-2 ${msg.sender?.id === seller?.sellerId
                                  ? "justify-content-end"
                                  : "justify-content-start"
                                  } w-100`}
                              >
                                {msg?.media?.url &&
                                  msg?.media?.type === "audio" && (
                                    <audio controls>
                                      <source
                                        src={msg.media.url}
                                        type="audio/mp3"
                                      />
                                    </audio>
                                  )}

                                {msg?.media?.type === "image" &&
                                  msg?.media?.url && (
                                    <img
                                      src={msg?.media?.url}
                                      className="chatImage"
                                    />
                                  )}

                                {msg?.type === "location" &&
                                  msg.location?.coordinates &&
                                  (() => {
                                    const lat = parseFloat(msg.location.coordinates[1]);
                                    const lng = parseFloat(msg.location.coordinates[0]);
                                    const href = `https://www.google.com/maps?q=${lat},${lng}`;


                                    return (
                                      <a
                                        href={href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          display: "block",
                                          height: "200px",
                                          width: "100%",
                                          marginTop: "10px",
                                          cursor: "pointer",
                                          borderRadius: "10px",
                                          overflow: "hidden",
                                        }}
                                      >
                                        <div
                                          style={{
                                            height: "200px",
                                            width: "100%",
                                            marginTop: "10px", // pointer cursor to show it's clickable
                                            cursor: "pointer",
                                          }}
                                          onClick={(e) => {
                                            e.preventDefault(); // Prevent default <a> if needed
                                            setSelectedLocation({
                                              lat,
                                              lng,
                                            });
                                          }}
                                        >
                                          <GoogleMap
                                            mapContainerStyle={{
                                              height: "100%",
                                              width: "100%",
                                              borderRadius: "10px",
                                              pointerEvents: "none",
                                            }}
                                            center={{ lat, lng }}
                                            zoom={15}
                                            options={{
                                              disableDefaultUI: true,
                                              gestureHandling: "none",
                                            }}
                                          >
                                            <MarkerF position={{ lat, lng }} />
                                          </GoogleMap>
                                        </div>
                                      </a>
                                    );
                                  })()}

                              </div>
                            </div>
                            {/* )} */}
                          </>
                        ))}

                        <div ref={messagesEndRef} />
                      </div>
                      <div className="InputEnter-Main">
                                    <textarea
         data-testing-id="input_Mainchat"
                          placeholder="How can I help you?"
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          onFocus={() => setMoreActions(false)}
                          onBlur={() => setMoreActions(false)}
    onKeyDown={(e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        handleSendMessage();
      }
    }}
    style={{
      width: "100%",
      height: "40px",
      border: "none",
      borderRadius: "0px",
      padding: "0px",
      resize: "none",
      fontSize: "14px",
      fontFamily: "inherit",
      overflow: "auto",
      lineHeight: message ? "" : "40px",
    }}
  />

                        <div className="icon-Plus-Btn">
                          <img
                            data-testing-id="plus_Mainchat"
                            src={PlusIcon}
                            alt=""
                            id="MoreActions"
                            className={`${moreActions ? "" : "active"}`}
                            onClick={() => setMoreActions(!moreActions)}
                          />
                          <div
                            className={`extra-icons ${moreActions ? "active" : ""
                              }`}
                          >
                            {uploadedImageUrl && (
                              <div style={{ marginTop: "10px" }}>
                                <img
                                  src={uploadedImageUrl}
                                  alt="Preview"
                                  width={150}
                                />
                              </div>
                            )}
                            {/* <div className="middelero">
                            <div className="imgman">
                              <div className="bot" >
                                <div className="cam">
                                  <img src={cam} />
                                </div>
                                <p>Camera</p>
                              </div>
                              <div className="bot">
                                <div className="cam">
                                  <img src={pro} />
                                </div>
                                <p>Products</p>
                              </div>
                              <div className="bot" onClick={() => setChatModal(true)}>
                                <div className="cam">
                                  <img src={ord} />
                                </div>
                                <p>Orders</p>
                              </div>
                            </div>
                          </div> */}
                            {/* {!sellerChat?.isAdmin && ( */}
                            <>
                              <img
                                data-testing-id="plus_Mainchat"
                                src={PlusIcon}
                                alt=""
                                id="Popover1"
                                onClick={toggle}
                              />
                              <Popover
                                placement="top"
                                isOpen={popoverOpen}
                                target="Popover1"
                                toggle={toggle}
                              >
                                <PopoverBody>
                                  <div className="imgman">
                                    {selectedChat.chatType !==
                                      "riderSeller" && (
                                        <div
                                          className="bot"
                                          onClick={() => {
                                            setVouchersModal(true);
                                            toggle();
                                          }}
                                        >
                                          <div
                                            className="cam"
                                            data-testing-id="Voucher"
                                          >
                                            <img src={ord} />
                                          </div>
                                          <p>Voucher</p>
                                        </div>
                                      )}

                                    <div
                                      className="bot"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setChatSelectOrderModal(true);
                                        toggle();
                                      }}
                                    >
                                      <div
                                        className="cam"
                                        data-testing-id="Products"
                                      >
                                        <img src={pro} />
                                      </div>
                                      <p>Products</p>
                                    </div>
                                    <div
                                      className="bot"
                                      onClick={() => {
                                        setChatModal(true);
                                        toggle();
                                      }}
                                    >
                                      <div
                                        className="cam"
                                        data-testing-id="orderS"
                                      >
                                        <img src={cam} />
                                      </div>
                                      <p>Orders</p>
                                    </div>
                                  </div>
                                </PopoverBody>
                              </Popover>
                            </>

                            {/* )} */}
                            <img
                              data-testing-id="location_Mainchat"
                              src={locationIcon}
                              alt=""
                              onClick={() => setShowMap(true)}
                              style={{
                                cursor: "pointer",
                                width: "19px",
                                height: "22px",
                              }}
                            />
                            <div style={{ position: 'relative', display: 'inline-block' }}>
                              <img
                                data-testing-id="Emojihappy_Mainchat"
                                src={EmojiHappy}
                                alt="Emoji"
                                onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                                style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                              />

                              {showEmojiPicker && (
                                <div style={{ position: 'absolute', top: '30px', zIndex: 999 }} ref={emojiRef}>
                                  <EmojiPicker
                                    onEmojiClick={(emojiData) => {
                                      setMessage((prev) => prev + emojiData.emoji);
                                      setShowEmojiPicker(false);
                                    }}
                                    theme={Theme.AUTO}
                                    width={300}
                                  />
                                </div>
                              )}
                            </div>
                            <img
                              data-testing-id="Mountaindew_Mainchat"
                              src={MountainDew}
                              alt="Upload"
                              onClick={handleImageClick}
                              style={{ cursor: "pointer" }}
                            />
                            <input
                              type="file"
                              accept="image/*"
                              ref={fileInputRef}
                              onChange={handleImageUpload}
                              style={{ display: "none" }}
                            />
                            <img
                              data-testing-id="Recording_mainChat"
                              src={isRecording ? greenvoice : MicrePhone}
                              onClick={() => {
                                if (isRecording) {
                                  stopRecording();
                                  handleSendMessage(); // optional: send audio if needed
                                } else {
                                  startRecording();
                                }
                              }}
                              alt=""
                            />
                          </div>
                          <button
                            data-testing-id="send_Mainchat"
                            onClick={() => {
                              // stopRecording();
                              handleSendMessage();
                            }}
                          >
                            <img src={Send} alt="" /> Send
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default MainChat;
